// Custom cursor is now handled via CSS with .cur files
// This component is kept for potential future enhancements

const CustomCursor = () => {
  // Cursor styling is applied via src/styles/cursor.css
  // Using Solo Leveling themed .cur files from public/cursors/
  return null;
};

export default CustomCursor;
